export const UniprotLink = (uniprot) => <a href={"https://www.uniprot.org/uniprotkb/" + uniprot.value} target="_blank" rel="noopener noreferrer"> {uniprot.value} </a>
